import { ExternalCell, ExternalRow } from '@cast/design-system';

import { DetailsRowContainer, DetailWitTitle } from './DetailsRowContainer';
import { OptimizationStatusEnabledChip } from './OptimizationStatusChips';
import { SystemOverrideResetEvent } from '../../../types';

export const SystemOverrideResetEventRow = (
  event: SystemOverrideResetEvent
) => {
  return (
    <DetailsRowContainer event={event}>
      <ExternalRow
        height={22}
        top={-12}
        sx={{ borderTopColor: 'transparent !important' }}
      >
        <ExternalCell startColumn={0} sx={{ width: '100% !important' }}>
          <DetailWitTitle
            title="Message:"
            detail="Deactivated the system override for the workload."
            titleVariant="light"
          />
        </ExternalCell>
      </ExternalRow>

      <ExternalRow
        height={22}
        top={-12}
        sx={{ borderTopColor: 'transparent !important' }}
      >
        <ExternalCell startColumn={0}>
          <DetailWitTitle
            title="Optimization status:"
            detail={<OptimizationStatusEnabledChip />}
            titleVariant="light"
          />
        </ExternalCell>
      </ExternalRow>
    </DetailsRowContainer>
  );
};
